import React from 'react';
import { connect } from "react-redux";
import Chart from "react-apexcharts";

import moment from 'moment'
import { int, clp, isEmpty, str, is_nori, fecha } from '../../utils'
import { fetchGastosJornada, isSuccess, cerrarJornada, fetchPedidosHora, fetchProductosVendidosJornada } from '../../api';
import { COMPLETED, CANCELED } from '../../utils/Status';
import { EFECTIVO, TRANSBANK, SODEXO, TRANSFERENCIA, APLICACIONES, payment_label, PAGO_ONLINE, AMIPASS } from '../../utils/PaymentTypes';
import { Confirm, Container, Divider, Grid, Header, Icon, Item, Label, Menu, Message, Segment, Statistic, Tab, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';
import { is_window_medium } from '../../reducers';
import { DELIVERY, is_delivery, typeIcon } from '../../utils/OrderTypes';
import { DETALLE_PEDIDO } from '../../utils/Routes';
import { fijar_jornada_detalle } from '../../actions';
import { pedidos_jornada_from_state } from '../../reducers/JornadaReducer';
import GastoItem from '../../components/GastoItem';
import { MensajeError } from '../../components/Mensajes';
import { permisos_fs } from '../../reducers/SessionReducer';
import Screen from '../Screen';
import { AppHeader } from '../../components';



class DetalleJornada extends Screen {
  state = {
    productos_vendidos: [],
    pedidos_hora: [],
    gastos: [],
    loading: true,
    network: false,
    confirm: false,
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false
        }
      },
      xaxis: {
        categories: ['12hrs', '13hrs', '14hrs', '15hrs', '16hrs', '17hrs', '18hrs', '19hrs']
      }
    },
    series: [
      {
        name: "series-1",
        data: [10, 40, 45, 15, 8, 60, 70, 91]
      }
    ]
  }

  async componentDidMount() {
    try {
      window.scrollTo(0, 0)
      const id = int(this.props.match.params.id)
      await this.props.fijar_jornada_detalle(id)
      const res2 = await fetchGastosJornada(id)
      if (isSuccess(res2)) {
        this.setState({ gastos: res2.data })
      }

      const pedidos_hora = await fetchPedidosHora(id)
      if (isSuccess(pedidos_hora)) {
        //console.log(pedidos_hora)
        this.setState({ pedidos_hora: pedidos_hora.data })
      }
      const productos_vendidos = await fetchProductosVendidosJornada(id)
      if (isSuccess(productos_vendidos)) {
        //console.log(productos_vendidos.data)
        this.setState({ productos_vendidos: productos_vendidos.data })
      }
    } catch (e) {
      console.log('[componentDidMount]', e)
    } finally {
      this.setState({ loading: false })
    }
  }

  networking = () => this.setState({ network: !this.state.network })

  cerrar = () => {
    this.toggleConfirm()
    this.networking()
    cerrarJornada(this.props.match.params.id).then(res => {
      if (isSuccess(res)) {
        this.volver()
      } else {
        this.setState({ error: res.data })
      }
    }).catch(console.log).finally(this.networking)
  }

  modificar = (_id) => {
    console.log('mod',_id)
    this.props.history.push(DETALLE_PEDIDO.replace(":id", _id))
  }

  volver = () => this.props.history.goBack()
  toggleConfirm = () => this.setState({ confirm: !this.state.confirm })

  render() {
    const { gastos, error, network, loading, confirm } = this.state
    const { jornadas, jornada_activa, match, pedidos, operador } = this.props
    const id = int(match.params.id)
    const jornada = jornadas.find(j => j.id === id)
    const created = moment(jornada.apertura)
    const closed = jornada.cierre !== null ? moment(jornada.cierre) : null
    const disabled = network || closed !== null || loading

    const completados = pedidos.filter(pedidoCompletado)
    const total_delivery = completados.reduce((t, v) => t + v.deliveryCost, 0)

    const gastos_totales = [ ...gastos]
    if (total_delivery > 0) {
      gastos_totales.push({
        id: 'gastos',
        monto: total_delivery,
        cantidad: 1,
        caja: true,
        concepto: { nombre_concepto: 'Repartidores'}
      })
    }

    const options = {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false
        }
      },
      xaxis: {
        categories: this.state.pedidos_hora.map(v => (v.hora + 'hrs'))
      }
    }
    const series = [
      {
        name: "pedidos-hora",
        data: this.state.pedidos_hora.map(v => v.cantidad)
      }
    ]

    const productos_vendidos = this.state.productos_vendidos.slice(0, 6)
    
    return (
      <div>
        <AppHeader>
          <Menu.Item onClick={this.volver}>
            <Icon name="chevron left" size="big" />
            Volver
          </Menu.Item>
          <Menu.Item>
            <div>
              Jornada
              <p>{id}</p>
            </div>
          </Menu.Item>
          {operador && <Menu.Item position="right" onClick={this.toggleConfirm} disabled={disabled}>
            <Icon name="ban" size="big" />
            Cerrar Jornada
          </Menu.Item>}
        </AppHeader>
        <Container>
          <Confirm open={confirm} onCancel={this.toggleConfirm} onConfirm={this.cerrar}
            content={`Seguro quieres cerrar la jornada ${id}?`} cancelButton="Volver" confirmButton="Cerrar Jornada" />
          <MensajeError content={error} />
          {jornada_activa === id ? <Active /> : null}
          {closed !== null ? <Closed /> : null}
          <Message>
            Fecha de Apertura: <strong>{created.format("dddd DD MMMM, HH:mm")}</strong>
          </Message>
          {closed !== null && 
          <Message>
            Fecha de Cierre: <strong>{closed.format("dddd DD MMMM, HH:mm")}</strong>
          </Message>
          }
          <Totales pedidos={completados} gastos={gastos_totales} busy={loading} small={this.props.small} />
          <Segment loading={loading}>
            <center><h3>Ventas por Hora</h3></center>
            <Chart
                options={options}
                series={series}
                type="bar"
                width="100%"
                height="300"
              />
          </Segment>
          <Segment loading={loading}>
            <center><h3>Productos mas vendidos</h3></center>
            <div>
              <Chart options={{
                labels: productos_vendidos.map(v => v.titulo),
                legend: {
                  position: 'bottom'
                }
              }} series={productos_vendidos.map((v) => v.total)} type="donut" width="100%" height={400}/>
              <Table basic='very' celled collapsing size="small" compact unstackable style={{ width: '100%'}}>
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell>Nombre</TableHeaderCell>
                    <TableHeaderCell>Cantidad</TableHeaderCell>
                    <TableHeaderCell>Total</TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.productos_vendidos.map((fila, index) => (
                    <TableRow key={index}>
                      <TableCell>{fila.titulo}</TableCell>
                      <TableCell>{fila.cantidad}</TableCell>
                      <TableCell>{clp(fila.total)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Segment>
          <AcordionGroup pedidos={pedidos} gastos={gastos_totales} small={this.props.small}
            busy={loading} onModificarClick={!closed && this.modificar}/>
        </Container>
      </div>
    )
  }
}

/* grafico de donut
<Chart options={{}} series={[44, 55, 41, 17, 15]} type="donut" width="380" />
*/

function Totales({ pedidos, gastos, busy, small }) {
  const efectivo = pedidos.filter(({ payment }) => payment === EFECTIVO).reduce(reduceProductos, 0)
  const otros = pedidos.filter(({ payment }) => payment !== EFECTIVO).reduce(reduceProductos, 0)
  const tarjetas = pedidos.filter(({ payment }) => payment === TRANSBANK).reduce(reduceProductos, 0)
  const sodexo = pedidos.filter(({ payment }) => payment === SODEXO).reduce(reduceProductos, 0)
  const transferencias = pedidos.filter(({ payment }) => payment === TRANSFERENCIA).reduce(reduceProductos, 0)
  const aplicaciones = pedidos.filter(({ payment }) => payment === APLICACIONES).reduce(reduceProductos, 0)
  const pagoonline = pedidos.filter(({ payment }) => payment === PAGO_ONLINE).reduce(reduceProductos, 0)
  const amipass = pedidos.filter(({ payment }) => payment === AMIPASS).reduce(reduceProductos, 0)

  const total_gastos = gastos.filter(g => g.caja).reduce(reduceGastos, 0)

  return (
    <div>
      <Segment loading={busy}>
        <Statistic.Group widths={small ? 1 : 3} size="mini">
          <Statistic>
            <Statistic.Value>{clp(tarjetas)}</Statistic.Value>
            <Statistic.Label>Tarjetas</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(sodexo)}</Statistic.Value>
            <Statistic.Label>Sodexo</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(transferencias)}</Statistic.Value>
            <Statistic.Label>Transferencias</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(aplicaciones)}</Statistic.Value>
            <Statistic.Label>Aplicaciones</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(pagoonline)}</Statistic.Value>
            <Statistic.Label>Pago Online</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(amipass)}</Statistic.Value>
            <Statistic.Label>Amipass</Statistic.Label>
          </Statistic>
        </Statistic.Group>
      </Segment>
      <Segment loading={busy}>
        <Statistic.Group widths={small ? 1 : 3} size="mini">
          <Statistic>
            <Statistic.Value>{clp(efectivo)}</Statistic.Value>
            <Statistic.Label>(1) Total Pedidos en Efectivo</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(otros)}</Statistic.Value>
            <Statistic.Label>(2) Total Pedidos Otros medios de pago</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(total_gastos)}</Statistic.Value>
            <Statistic.Label>(3) Total Gastos</Statistic.Label>
          </Statistic>
        </Statistic.Group>
      </Segment>
      <Segment loading={busy}>
        <Statistic.Group widths={small ? 1 : 2} size="mini">
          <Statistic>
            <Statistic.Value>{clp(efectivo - total_gastos)}</Statistic.Value>
            <Statistic.Label>Total Caja (1) - (3)</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{clp(efectivo + otros)}</Statistic.Value>
            <Statistic.Label>Total Ventas (1) + (2)</Statistic.Label>
          </Statistic>
        </Statistic.Group>
      </Segment>
    </div>
  )
}


function AcordionGroup({ pedidos, gastos, small, onModificarClick, busy }) {
  const pedidos_terminados = pedidos.filter(pedidoCompletado)
  const pedidos_anulados = pedidos.filter(({ status }) => status === CANCELED)
  const pedidos_delivery = pedidos_terminados.filter(v => v.type === DELIVERY)
  let repartidores = []
  
  for (let v of pedidos_delivery) {
    let despacho = v.deliveryCost
    let cantidad = 1

    if (v.deliveryMan && v.deliveryMan !== null) {
      const man = v.deliveryMan
      const repartidor = repartidores.find(v => v.email === man.email)
      if (repartidor) {
        despacho += repartidor.total
        cantidad += repartidor.cantidad
        repartidores = repartidores.filter(v => v.email !== man.email)
      }
      repartidores.push({
        email: man.email,
        nombre: man.nombre,
        total: despacho,
        cantidad
      })
    } else {
      repartidores.push({
        email: '',
        nombre: 'No asignado',
        total: despacho,
        cantidad
      })
    }
  }

  const panes = [
    {
      menuItem: (
        <Menu.Item key='facturados'>
          Facturados<Label color="blue">{pedidos_terminados.length}</Label>
        </Menu.Item>
      ),
      render: () => <Tab.Pane loading={busy}>
        <Grid divided="vertically" doubling={small}>
          {pedidos_terminados.sort(sortPedidos).map(v => <PedidoItem key={v.id || v._id} {...v} small={small} onClick={onModificarClick} />)}
        </Grid>
      </Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item key='anulados'>
          Anulados<Label color="blue">{pedidos_anulados.length}</Label>
        </Menu.Item>
      ),
      render: () => <Tab.Pane loading={busy}>
        <Grid divided="vertically">
          {pedidos_anulados.sort(sortPedidos).map(v => <PedidoItem key={v.id || v._id} {...v} small={small} />)}
        </Grid>
      </Tab.Pane>,
    },
    {
      menuItem: (
        <Menu.Item key='gastos'>
          Gastos<Label color="blue">{gastos.length}</Label>
        </Menu.Item>
      ),
      render: () => <Tab.Pane loading={busy}>
        <Item.Group divided>
          {gastos.map(v => <GastoItem key={v.id} {...v} />)}
        </Item.Group>
      </Tab.Pane>
    },
    {
      menuItem: (
        <Menu.Item key='repartidores'>
          Repartos<Label color="blue">{repartidores.length}</Label>
        </Menu.Item>
      ),
      render: () => <Tab.Pane loading={busy}>
        <Item.Group divided>
          {repartidores.map(v => <Repartidor key={v.email} { ...v } />)}
        </Item.Group>
      </Tab.Pane>
    },
  ]

  return (
    <Tab panes={panes} className="cs-mt-3" 
      menu={{ attached: !small, tabular: !small, stackable: true, widths: 4 }} />
  )
}

const Repartidor = ({ email, nombre, total, cantidad }) => {
  return (
    <Item>
      <Item.Content>
        <Item.Header>{nombre}</Item.Header>
        <Item.Meta>{email}</Item.Meta>
        <Item.Description>{clp(total)}</Item.Description>
      </Item.Content>
    </Item>
  )
}

const PedidoItem = ({ _id, index, channel, type, pay, payment, products, deliveryCost, user, motivo, deliveryMan, onClick, datetime }) => {
  const _onClick = () => onClick(_id)

  return (
    <Grid.Row onClick={onClick ? _onClick : undefined} className={onClick ? "cs-pointer" : ""}>
      <Grid.Column width={3}>
        <div style={{ textAlign: 'center' }}>
          <Icon name={typeIcon(type)} size="big"/>
          <div>{type}</div>
          {onClick && <Icon name="edit" />}
        </div>
      </Grid.Column>
      <Grid.Column width={13}>
        <div>
          <Header>{index} - {isEmpty(user.name) ? 'Anonimo' : `${user.name} ${str(user.apellido)}`}</Header>
          <div>{fecha(datetime)}</div>
          <div>{user.address}</div>
          <div>{user.phone}</div>
          <Label.Group>
            <Label>{payment_label(payment)}</Label>
            {pay && <Label color="green">Pagado</Label>}
            {is_nori(channel) && <Label color="red">App</Label>}
          </Label.Group>
          {is_delivery(type) && <DeliveryMan deliveryMan={deliveryMan} />}
          {!isEmpty(motivo) && <Label color="red">Motivo: {motivo}</Label>}
          <div>
            {products.map((product, index) => (
              <div key={index}>
                <Divider />
                <ProductItem label={`${product.index} - ${product.title} x ${product.quantity}`} value={product.price} />
              </div>
            ))}
            {is_delivery(type) &&
            <>
              <Divider />
              <ProductItem label="Delivery" value={deliveryCost} />
            </>
            }
            <Divider />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div><strong>Total</strong></div>
              <div><strong>{clp(products.reduce(totalProductos, deliveryCost))}</strong></div>
            </div>
          </div>
        </div>
      </Grid.Column>
    </Grid.Row>
  )
}

const DeliveryMan = ({ deliveryMan }) => {
  const nombre = deliveryMan && deliveryMan !== null ? deliveryMan.nombre : 'No asignado'
  return (
    <div style={{ marginTop: 8 }}>
      <div><strong>Repartidor: {nombre}</strong></div>
    </div>
  )
}

const ProductItem = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <i>{label}</i>
    <i>{clp(value)}</i>
  </div>
)

const Active = () => (
  <Message color="green">
    <strong>Esta jornada esta activa.</strong>
  </Message>
)

const Closed = () => (
  <Message color="yellow">
    <strong>Esta jornada esta cerrada.</strong>
  </Message>
)

function pedidoCompletado({ status }) {
  return status === COMPLETED
}

function reduceProductos(t, v) {
  return t + (v.products.reduce(totalProductos, 0))
}

function reduceProductosDelivery(t, v) {
  const cost = v.deliveryCost ? v.deliveryCost : 0
  return t + (v.products.reduce(totalProductos, cost))
}

function totalProductos(t, v) {
  return t + (v.price *  v.quantity)
}

function reduceGastos(t, v) {
  return t + (v.cantidad * v.monto)
}

function sortPedidos(a, b) {
  return a.index - b.index
}

const mapStateToProps = (state) => ({
  jornadas: state.jornadas,
  jornada_activa: state.jornada_activa,
  pedidos: pedidos_jornada_from_state(state),
  small: is_window_medium(state),
  operador: permisos_fs(state) >= 1024
})

export default connect(mapStateToProps, { fijar_jornada_detalle })(DetalleJornada)